export type ProblemType =
  | 'addition'
  | 'subtraction'
  | 'multiplication'
  | 'division'
  | 'radical'
  | 'exponent'

export interface Problem {
  id: string
  question: string
  answer: number | string
  type: ProblemType
  options?: (number | string)[] // For multiple choice
}

export type GameMode = 'set_count' | 'infinite' | 'no_errors'
export type InputType = 'multiple_choice' | 'fill_in_blank'
export type ProblemOrientation = 'horizontal' | 'vertical'
export type NumberType = 'positive' | 'negative' | 'both'
export type RadicalType = 'perfect_squares' | 'simplify'
export type ExponentType = 'squares' | 'cubes' | 'custom' | 'mixed'
export type NumberFormat = 'whole' | 'decimal'
export type ValueType = 'integers' | 'fractions' | 'both'
export type Difficulty = 'easy' | 'medium' | 'hard'

export interface AdvancedOptions {
  orientation: ProblemOrientation
  numberType: NumberType
  radicalType: RadicalType
  exponentType: ExponentType
  customExponent?: number
  maxExponentResult: number
  numberFormat: NumberFormat
  valueType: ValueType
  digitCount: number
  difficulty: Difficulty
  answerChoiceCount: 4 | 6
}

export interface GameSettings {
  mode: GameMode
  inputType: InputType
  problemCount?: number
  problemTypes: ProblemType[]
  advancedOptions: AdvancedOptions
}

export interface GameStats {
  correct: number
  total: number
  streak: number
  bestStreak: number
  startTime: number
  endTime?: number
  history: {
    problem: Problem
    userAnswer: string
    isCorrect: boolean
    timeTaken: number
  }[]
}

// Default advanced options
export const DEFAULT_ADVANCED_OPTIONS: AdvancedOptions = {
  orientation: 'horizontal',
  numberType: 'positive',
  radicalType: 'perfect_squares',
  exponentType: 'squares',
  maxExponentResult: 1000,
  numberFormat: 'whole',
  valueType: 'integers',
  digitCount: 2,
  difficulty: 'medium',
  answerChoiceCount: 4,
}
